:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;
}

.push-body {
  &--content {
    height: 100%;
  }
  &--menu {
    display: none;
  }
}

.alerts {
  height: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;

  &.is-loading {
    .company-selector-loader {
      display: block;
    }

    .company-selector {
      display: none;
    }
  }

  &.is-error {
    .alerts-header,
    .alerts-content {
      display: none;
    }

    .loading-error {
      display: block;
    }
  }
}

.company-selector-loader {
  display: none;
  width: 160px;
}
.loader {
  margin-top: calc(2 * var(--spacer));

  .smartview-loader {
    padding-right: calc(2 * var(--spacer));
    padding-left: calc(3 * var(--spacer));
    position: relative;

    &:last-child {
      padding-top: var(--spacer);
    }

    &:not(:first-of-type) {
      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        height: 1px;
        width: calc(100% - calc(5 * var(--spacer)));
        left: calc(3 * var(--spacer));
        background-color: var(--secondary-color-10);
      }
    }

    &:first-child {
      padding-bottom: calc(2 * var(--spacer));
    }
  }
}

.alerts-header {
  display: flex;
  flex-direction: column;
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;

  &--top {
    display: flex;
    justify-content: space-between;
  }
}

.title {
  color: var(--main-titles-inputs-600);
}

.subtitle {
  color: var(--chart-300-icon-buttons);
}

.loading-error {
  display: none;
  height: auto;
  width: 500px;
  margin: auto;

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}

.alerts-content {
  flex-grow: 2;
  height: 100%;

  .alerts-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}
